var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"list-grid"},[_vm._l((_vm.items),function(item,i){return [_c('Checkmark',{key:`${i}-check`}),_c('span',{key:i},[_vm._v(_vm._s(item))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }